module.exports = __webpack_public_path__ + "img/clon.98567f56.svg";